module.exports = __webpack_public_path__ + "img/2025-12-20c_3.0062897f.jpg";